export default "__VITE_ASSET__CuobkfRt__"